export default function getCountryTranslation(
  code: string,
  lang: Intl.Locale['language'],
) {
  return new Intl.DisplayNames([lang], { type: 'region' }).of(
    code.toUpperCase(),
  )
}
